import RegExp from '@/utils/regExp.js';

export default {
  data() {
    return {
      idTypeList: [],
      form: {
        name: '',
        idType: '1',
        idCard: '',
        mobile: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入您的姓名', trigger: 'blur'}
        ],
        idType: [
          { required: true, message: '请选择您的证件类型', trigger: 'change'}
        ],
        idCard: [
          { required: true, message: '请输入您的证件号', trigger: 'blur'},
          { pattern: RegExp.idCard, message: '请输入正确的证件号', trigger: 'blur'}
        ],
        mobile: [
          { required: true, message: '请输入您的手机号码', trigger: 'blur'},
          { pattern: RegExp.phone, message: '请输入正确的手机号', trigger: 'blur'}
        ]
      }
    };
  },
  created() {
    // 获取证件类型列表
    this.getIdTypeList();
  },
  methods: {
    // 更新个人手机号
    updateMobile() {
      this.$store.commit('UPDATE_PERSON_MOBILE', this.form.mobile);
    },
    // 获取字典：证件类型列表
    getIdTypeList() {
      this.$store.dispatch('getSelectDictList', 'ID_TYPE').then(res => {
        if (res.code === '0') {
          this.idTypeList = res.data;
        }
      });
    },
    validateForm() {
      let isValid = false;
      this.$refs['form'].validate(valid => {
        isValid = valid;
      });
      return isValid;
    },
    // 开户名称
    updateName() {
      this.$store.commit('UPDATE_ACC_NAME', this.form.name );
    }
  }

};
